import React, { useState } from "react";
import { Table, Tabs, Heading } from "@radix-ui/themes";
import RadixTable from "../Component/RadixTable";
import PaginationBar from "../Component/PaginationBar";

const header = [
  "Type",
  "Category",
  "Title",
  "Goal",
  "Process fee",
  "After RAFL fee",
];
const data = [
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
  {
    cellData: [
      "Charity",
      "Health",
      "need for help...",
      "$5000",
      "$4320",
      "$3220",
    ],
  },
];

const Funds = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalItems = data.length; // Example total items
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const tableBodyData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  return (
    <div>
      <Heading align="left" m="5" size="8" weight="bold">
        Funds
      </Heading>
      <Tabs.Root defaultValue="Submitted" mx="5" mb="5">
        <Tabs.List color="gray" highContrast>
          <Tabs.Trigger value="Submitted">Submitted</Tabs.Trigger>
          <Tabs.Trigger value="Approved">Approved</Tabs.Trigger>
          <Tabs.Trigger value="Completed">Completed</Tabs.Trigger>
        </Tabs.List>
      </Tabs.Root>
      <Table.Root variant="surface" size="3" mx="5" layout="auto">
        <RadixTable
          header={header}
          data={tableBodyData}
          routeUrl={"/campaigns-form"}
        />
      </Table.Root>
      {data.length > 10 && (
        <PaginationBar
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default Funds;
